import React from 'react';
import type { DermatologiaData } from '../../hooks/useConsultationForm';
import LesionAssessment from './LesionAssessment';
import DermaHistory from './DermaHistory';
import DermoscopyTreatment from './DermoscopyTreatment';
import SectionNumberBadge from '../SectionNumberBadge';

interface DermatologiaSectionProps {
  dermatologiaData: DermatologiaData;
  setDermatologiaField: (section: keyof DermatologiaData, field: string, value: any) => void;
  sectionNumber?: string;
}

const DERMOSCOPY_FIELDS = new Set([
  'performed', 'findings', 'pattern', 'ABCD_rule_score', 'melanoma_suspected', 'biopsy_recommended',
]);

const DermatologiaSection: React.FC<DermatologiaSectionProps> = ({ dermatologiaData, setDermatologiaField, sectionNumber }) => {
  return (
    <div className="row mb-4" data-section="dermatologica">
      <div className="col-sm-12">
        <div className="card" style={{ borderColor: '#8b5cf6' }}>
          <div className="card-header text-white" style={{ backgroundColor: '#8b5cf6' }}>
            <h4 className="card-title mb-0">
              {sectionNumber && <SectionNumberBadge number={sectionNumber} inverse />}
              <i className="fa fa-paint-brush me-2"></i>
              Evaluación Dermatológica
            </h4>
          </div>
          <div className="card-body">
            <LesionAssessment
              data={dermatologiaData.lesion}
              onChange={(field, value) => setDermatologiaField('lesion', field, value)}
            />

            <DermaHistory
              data={dermatologiaData.history}
              onChange={(field, value) => setDermatologiaField('history', field, value)}
            />

            <DermoscopyTreatment
              dermoscopy={dermatologiaData.dermoscopy}
              treatment={dermatologiaData.treatment_derma}
              onFieldChange={(section, field, value) =>
                setDermatologiaField(section as keyof DermatologiaData, field, value)
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DermatologiaSection;
